export const isProd = process.env.NODE_ENV === 'production';
export const apiBase = process.env.VUE_APP_API_BASE || '';
export const apiNamespace = process.env.VUE_APP_API_NAMESPACE || '';
export const baseUrl = apiBase + apiNamespace;
export const useCookies = process.env.VUE_APP_USE_COOKIES === 'true';
export const wpApiBase = process.env.VUE_APP_WP_API_BASE || '';
